import React from 'react'
import Skeleton from '@mui/material/Skeleton';
import { styled } from "@mui/system";
import Stack from "@mui/material/Stack";
import config from "../../../next.config";
import style from "../../../styles/mystyle.module.css";
const CustomeBg = styled("div")(({ theme, locale }) => ({
  backgroundImage: `url(${config.basePath}/assest/BGM.webp)`,
}));
export default function LoadingBackground() {
  return (
    <CustomeBg className={style.BackgroundHakeemMedical}>


      <div className={style.Container}>
      <div className={style.allcard}>
                 <br />
                 {/* {mobile ? "" : <><br /></> }   */}

                  <div className={style.cardBooking}>
                    <div className={style.profileMedical}>
                      <div className={style.profileandtextcardDetails}>
                        <div className={style.profile1}>
                        <Stack
                            direction="row"
                            spacing={1}
                            className={style.StackBook}

                          >
                             <Skeleton variant="circular" width={120} height={120}    /> 
                          </Stack>
                            </div>
                            <div className={style.profile2}>
                          <div className={style.textaboutdoctor1card}>
                          <Skeleton variant="text" sx={{ fontSize: '1rem',margin:"auto" }} width={120} />
                          </div>
                          <div className={style.textaboutdoctor2card}>
                          <Skeleton variant="text" sx={{ fontSize: '1rem',margin:"auto" }} width={120}  />
                          </div>
                         
                        </div>
                        <div className={style.profile3}>
                        <Skeleton variant="text" sx={{ fontSize: '1rem',margin:"auto" }} width={120}  />
                        </div>
                            </div>
                            </div>
                            </div>
                            </div>

        </div>
        </CustomeBg>
  )
}
